var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.convertDate}},[_vm._v(" "+_vm._s(_vm.format)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }